import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { I18nModule } from '@spartacus/core'
import { SpinnerModule } from '@spartacus/storefront'
import { MaterialModule } from '../../material.module'
import { CustomPaginationModule } from '../custom-pagination/custom-pagination.module'
import { CustomTableComponent } from './component/custom-table.component'
import { ColumnControlsModule } from './controls/column-controls.module'
import { CreditClaimsHistoryRowComponent } from './rows/credit-claims-history-row/credit-claims-history-row.component'
import { DefaultRowComponent } from './rows/default-row/default-row.component'
import { DispenserAgreementHistoryRowComponent } from './rows/dispenser-agreement-history-row/dispenser-agreement-history-row.component'
import { DispenserAgreementProductRowComponent } from './rows/dispenser-agreement-product-row/dispenser-agreement-product-row.component'
import { DispenserShipmentHistoryRowComponent } from './rows/dispenser-shipment-history-row/dispenser-shipment-history-row.component'
import { PriceAgreementHistoryRowComponent } from './rows/price-agreement-history-row/price-agreement-history-row.component'
import { ProductUpdatesRowComponent } from './rows/product-updates-row/product-updates-row.component'
import { RebateClaimsHistoryRowComponent } from './rows/rebate-claims-history-row/rebate-claims-history-row.component'
import { SavedCartRowComponent } from './rows/saved-cart-row/saved-cart-row.component'
import { ShipmentCreditClaimRowComponent } from './rows/shipment-credit-claim-row/shipment-credit-claim-row.component'
import { CustomTableService } from './service/custom-table.service'

@NgModule({
  declarations: [
    CustomTableComponent,
    DefaultRowComponent,
    PriceAgreementHistoryRowComponent,
    DispenserAgreementProductRowComponent,
    SavedCartRowComponent,
    DispenserAgreementHistoryRowComponent,
    ShipmentCreditClaimRowComponent,
    DispenserShipmentHistoryRowComponent,
    RebateClaimsHistoryRowComponent,
    CreditClaimsHistoryRowComponent,
    ProductUpdatesRowComponent
  ],
  exports: [CustomTableComponent],
  imports: [CommonModule, I18nModule, MaterialModule, CustomPaginationModule, SpinnerModule, ColumnControlsModule],
  providers: [CustomTableService]
})
export class CustomTableModule {}
